// ============================================================
//  Trace-Regel — EINE Stelle für Maßnahmen (build.ts), Aufschlüsselung (analysis.ts) und Plan (plan.ts).
//
//  Eine Person kann dieselbe Rolle in mehreren Mandanten eines Systems tragen — je Konto ein
//  Treiber mit eigenem Trace. Für die Person zählt der STRENGSTE Befund:
//    „genutzt"      sobald ein Konto den Wert genutzt hat
//    „kein Trace"   sobald ein Konto ohne Nachweis ist (und keines „genutzt")
//    „nie genutzt"  nur, wenn ALLE Konten das belegen
//  Befund A5: vorher rechnete build.ts mit dem Trace des ERSTEN gefundenen Treibers, der Plan mit
//  dem strengsten — dieselbe Person tauchte in zwei Trace-Balken auf. Jetzt gilt überall diese Regel.
// ============================================================
import type { Person, TraceState } from "./types";

export const TRACE_SEVERITY: Record<TraceState, number> = { "nie-genutzt": 0, "kein-trace": 1, genutzt: 2 };

/** Strengster Trace einer Person für EINE Maßnahme über alle ihre Konten; null, wenn sie die Maßnahme nicht trägt. */
export function personTraceFor(p: Person, leverId: string): TraceState | null {
  let best: TraceState | null = null;
  for (const d of p.drivers) {
    if (d.leverId !== leverId) continue;
    if (best === null || TRACE_SEVERITY[d.trace] > TRACE_SEVERITY[best]) best = d.trace;
  }
  return best;
}

/** Strengster Trace aus einer Liste von Befunden (dieselbe Regel, ohne Person). */
export function strictestTrace(traces: Iterable<TraceState>): TraceState | null {
  let best: TraceState | null = null;
  for (const t of traces) if (best === null || TRACE_SEVERITY[t] > TRACE_SEVERITY[best]) best = t;
  return best;
}
